export const PLATFORM_FEATURE_TABS = [
    { id: "online-auction", label: "Online Auction" },
    { id: "reverse-auction", label: "Reverse Auction" },
    { id: "private-sale", label: "Private Sale" },
    { id: "ai-inspection-agents", label: "AI Inspection Agents" },
    { id: "enquiry-communication-management", label: "Enquiry & Communication Management" },
    { id: "property-valuation-updates", label: "Property Valuation Updates" },
] as const;

export type PlatformFeatureTabId = (typeof PLATFORM_FEATURE_TABS)[number]["id"];

export interface PlatformFeature {
    title: string;
    description: string;
}

export const PLATFORM_FEATURES_BY_TAB: Record<
    PlatformFeatureTabId,
    PlatformFeature[]
> = {
    "online-auction": [
        {
            title: "Real-time competitive bidding",
            description:
                "Buyers compete live from any device, driving stronger sale prices."

        },
        {
            title: "Complete seller visibility",
            description:
                "You see every bid the moment it happens, no filtered agent feedback.",
        },
        {
            title: "Faster and more modern",
            description:
                "A streamlined digital auction ideal for today’s mobile first buyer.",
        },
    ],
    
    "reverse-auction": [
        {
            title: "Transparent, Buyer-Ready Pricing",
            description:
                "Properties launch above reserve and reduce in price at set intervals, giving buyers complete clarity from the start.",
        },
        {
            title: "Instant, Digital Purchase Capability",
            description:
                "The “Buy Now” feature creates real time urgency and lets the first committed buyer secure the property instantly from anywhere.",
        },
        {
            title: "Vendor-Optimised Selling Outcomes",
            description:
                "The reverse auction format gives sellers greater control while generating competitive tension, even in lower competition markets. It delivers faster, more predictable results.",
        },
    ],

    "private-sale": [
        {
            title: "Instant digital offers",
            description:
                "Buyers can submit offers anytime with instant notifications.",
        },
        {
            title: "Automated negotiation workflows",
            description:
                "We handle the back-and-forth keeping deals moving fast.",
        },
        {
            title: "Transparent and low-pressure",
            description:
                "Perfect for sellers who prefer a simple, commission-free process.",
        },
    ],

    "ai-inspection-agents": [
        {
            title: "Property-specific AI knowledge base",
            description: "Every property gets an AI agent trained on its features, documents, and buyer activity.",
        },
        {
            title: "Instant, accurate answers",
            description:
                "Buyers can ask questions such as “When was this built?” or “What’s interest been like?” and get immediate, consistent responses.",
        },
        {
                title: "Increased buyer confidence",
            description: "A market-first feature that reduces misinformation and accelerates decision-making.",
        },
    ],
     
    "enquiry-communication-management": [
        {
            title: "Centralised buyer communication",
            description:
                "All messages and enquiries are managed in one dashboard.",
        },
        {
            title: "AI-assisted responses",
            description:
                "Every enquiry is answered quickly and consistently with no missed leads.",
        },
        {
            title: "Integrated VoIP with full visibility",
            description:
                "All conversations are tracked, creating a proprietary dataset that improves outcomes.",
        },
    ],

    "property-valuation-updates": [
        {
            title: "Live data-driven valuations",
            description:
                "Valuations adjust with real-time market data, comparable sales and buyer activity.",
        },
        {
            title: "Instant campaign insights",
            description:
                "Track buyer interest and market movement throughout the sale.",
        },
        {
            title: "More accurate than agent feedback",
            description:
                "Powered by data — not opinion.",
        },
    ],
};

export interface PlatformFeaturesSectionCopy {
    heading: string;
}

export const PLATFORM_FEATURES_SECTION: PlatformFeaturesSectionCopy = {
    heading: "What Our Platform can do",
};

export const PLATFORM_FEATURES_DEFAULT_TAB_ID: PlatformFeatureTabId =
    "reverse-auction";


